<script>
	import DropdownCheckbox from "../../../../components/DropdownCheckbox/DropdownCheckbox.svelte";
	import CustomButton from "../../../../components/CustomButton/CustomButton.svelte";
	import CustomDatePicker from "../../../../components/CustomDatePicker/CustomDatePicker.svelte";
	import CustomSearch from "../../../../components/CustomSearch/CustomSearch.svelte";
	import LimitSize from "../../../../components/SizeSelect/limitSize.svelte";
	import { Col, Row } from "@sveltestrap/sveltestrap";
	import { initPage, masterData } from "src/store/store";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";
	import { debounce } from "lodash";
	import { navigate } from "svelte-routing";
	import LastUpdatedDateTime from "src/components/LastUpdatedDateTime/LastUpdatedDateTime.svelte";
	import {
		carAssetOwnersDropdownCheckBoxOptions,
		getOrDefault,
		updateCheckboxOptions,
	} from "src/utils/misc";

	export let handleVehicleSearch = () => {};
	export let changeSearchParams = () => {};
	export let params = {};

	let isOpen = false;

	$: options = updateCheckboxOptions(
		carAssetOwnersDropdownCheckBoxOptions($masterData.carAssetOwners),
		params.assetOwnerId
	);

	$: plateNo = getOrDefault(params.plateNo, "");
	$: vehicleId = getOrDefault(params.vehicleId, "");
	$: investigator = getOrDefault(params.investigator, "");
	$: createdAt = getOrDefault(params.createdAt, "");

	const debouncedInput = debounce((e) => handleChange(e), 1000);

	function handleChange(value) {
		changeSearchParams({ ...value, page: 1, pageNumber: 1 });
		initPage.set(1);
	}

	function resetFilter() {
		initPage.set(1);
		navigate("/issues/case-management?tab=Investigating");
		changeSearchParams("");
	}

	function toggle() {
		isOpen = !isOpen;
	}
</script>

<Row style="padding-right: 0">
	<Col xs={12}>
		<Row>
			<Col xs={10}>
				<Row class="gx-2">
					<Col>
						<CustomSearch
							loadOptions={handleVehicleSearch}
							id={`plateNo`}
							type="text"
							placeholder={`Vehicle No`}
							bind:value={plateNo}
							containerClasses={`search-icon`}
							onSelect={(e) => {
								plateNo = e.detail.label;
								vehicleId = e.detail.value;
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
							handleClear={() => {
								plateNo = "";
								vehicleId = "";
								handleChange({
									vehicleId,
									plateNo,
								});
							}}
						/>
					</Col>
					<Col>
						<CustomDatePicker
							onChange={(e) => {
								handleChange({
									createdAt: e.detail,
								});
							}}
							value={createdAt}
							name="createdAt"
							isRange={false}
							placeholder={"Case Created"}
						/>
					</Col>
					<Col>
						<CustomInput
							placeholder="Investigator"
							search
							bind:value={investigator}
							onInput={(e) =>
								debouncedInput({
									[e.target.name]: e.target.value,
								})}
							name="investigator"
						/>
					</Col>
					<Col>
						<DropdownCheckbox
							categoryName="All Asset Owner"
							{options}
							id="assetOwnerId"
							{isOpen}
							{toggle}
							refetch={handleChange}
						/>
					</Col>
					<Col class="d-flex align-items-center">
						<CustomButton
							style="border-color: transparent; font-weight: bold;"
							buttonText="Clear filters"
							on:click={resetFilter}
							color="secondary"
						/>
					</Col>
				</Row>
			</Col>
			<Col xs={2} style="position:relative; padding-right:0">
				<LimitSize />

				<div class="d-flex justify-content-end">
					<LastUpdatedDateTime />
				</div>
			</Col>
		</Row>
		<Row class="mb-3">
			<Col xs={9}>
				<Row />
			</Col>
		</Row>
	</Col>
</Row>

<style>
	:global(.filter-row-spacing) {
		margin-bottom: -22px;
	}
</style>
